/**
 * Human-readable fallback for a raw status token when no i18n key exists.
 *
 * Backend (GS) statuses arrive as snake_case tokens like `pending_approval` or
 * `draft`. Used as the `defaultValue` for `t('status.<x>')` so an untranslated
 * status renders as "Pending Approval" instead of the raw `pending_approval`.
 * A translated status (mock/HTL statuses, or the GS ones added to the locales)
 * still wins — this only formats what has no key.
 */
export function humanizeStatus(status) {
  if (!status) return '';
  return String(status)
    .replace(/[_-]+/g, ' ')
    .trim()
    .replace(/\b\w/g, (ch) => ch.toUpperCase());
}
